import Navbar from "../../../components/dashboard/navbar/Navbar"
import Sidebar from "../../../components/dashboard/sidebar/Sidebar"
import Transactions from "../../../components/dashboard/transactions/Transactions"
import styles from "../layout.module.css"

import { selectSideNavOpen } from "../../../redux/slices/sharedSlice"
import { toggleSideNav } from "../../../redux/slices/sharedSlice"
import { useSelector } from "react-redux";
import { useState } from "react";

const TransactionsPage = () => {

    const open = useSelector(selectSideNavOpen)

    return (
        <section className={styles.pageContainer}>
            <div className={`${open ? styles.leftBarOpen : styles.leftBarClosed}`}>
                <Sidebar />
            </div>
            <div className={`${open ? styles.rightBarOpen : styles.rightBarClosed}`}>
                <Navbar page="Transactions" />
                <div className={styles.mainBar}>
                    <Transactions />
                </div>
            </div>
        </section>
    )
}

export default TransactionsPage